import { useQuery, UseQueryOptions, UseQueryResult } from '@tanstack/react-query';
import { FirebaseError } from 'firebase/app';

import { GoodPracticesFirestoreResponse } from '../types';
import { fetchDocumentsFromCollection } from './utils/fetchDocumentsFromCollection';

export const useGetGoodPracticesFromFirestore = (
  id: string,
  options?: UseQueryOptions<GoodPracticesFirestoreResponse[], FirebaseError>,
): UseQueryResult<GoodPracticesFirestoreResponse[], FirebaseError> => useQuery<
    GoodPracticesFirestoreResponse[], FirebaseError>({
      queryKey: [`hotels/${id}/goodPractise`] as const,
      queryFn: async () : Promise<GoodPracticesFirestoreResponse[]> => {
        const data = await fetchDocumentsFromCollection<GoodPracticesFirestoreResponse>(
          `hotels/${id}/goodPractise`,
        );
        return data.map((item) => ({
          id: item.id,
          title: item.title,
          cover: item.cover,
          description: item.description,
          fileUrl: item.fileUrl,
          logo: item.logo,
          createdAt: item.createdAt,
          order: item.order,
        }));
      },
      retry: 0,
      ...options,
    });
